import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import {
    HeadsetRounded,
    InfoRounded,
    TvRounded,
} from "@mui/icons-material";

const PlayerInfo = ({
    media,
    watchType,
    dispatch,
    setWatchType,
    setShowEpisodes,
}) => {
    return (
        <Box
            sx={{
                padding: 1,
                display: "flex",
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    backgroundColor: "#1e1e1e",
                    overflow: "hidden", // Ensure text doesn't bleed out
                }}
            >
                <Typography
                    sx={{
                        color: "#ffffff",
                        fontSize: "16px",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "300px", // Limit width to prevent pushing buttons
                    }}
                >
                    {media.titre}
                </Typography>
                <Typography
                    sx={{
                        color: "#ffffff88",
                        fontSize: "16px",
                        fontWeight: "bold",
                    }}
                >
                    {"Inexploré"}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                }}
            >
                <Tooltip
                    title={
                        watchType === "watch"
                            ? "Passer en mode écoute"
                            : "Passer en mode vidéo"
                    }
                    placement="top"
                >
                    <IconButton
                        onClick={() => {
                            dispatch(
                                setWatchType(watchType === "watch" ? "listen" : "watch"),
                            );
                        }}
                        sx={{
                            color: "white",
                            backgroundColor: (theme) => theme.palette.videoColors.button,
                            "&:hover": {
                                backgroundColor: (theme) =>
                                    theme.palette.videoColors.buttonHover,
                            },
                        }}
                    >
                        {watchType === "watch" ? <HeadsetRounded /> : <TvRounded />}
                    </IconButton>
                </Tooltip>
                <Tooltip title={"Voir la liste des épisodes"} placement="top">
                    <IconButton
                        onClick={() => {
                            setShowEpisodes(true);
                        }}
                        sx={{
                            color: "white",
                            backgroundColor: (theme) => theme.palette.videoColors.button,
                            "&:hover": {
                                backgroundColor: (theme) =>
                                    theme.palette.videoColors.buttonHover,
                            },
                        }}
                    >
                        <InfoRounded />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default PlayerInfo;
